Event.$on('selectedFilter', function(filter) {
	MicroPanels.filter = filter
})
Event.$on('selectedLocale', function(locale) {
	MicroPanels.locale = locale
})
Event.$on('selectedGroupSize', function(groupSize) {
	MicroPanels.groupSize = groupSize
})

const MicroPanels = new Vue({
	el: '#panels',
	data: {
		destination: Project_micropanel.destination,
		panels: Project_micropanel.panels,
		buttons: Project_micropanel.buttons,

		frontpage: true,
		subpage: false,

		currentTimer: 0,
		stopTimer: false,
		selectedPanel: null,
		selectedPage: null,
		selectedChild: null,
		selectedBlog: null,
		ibeActive: false,

		microPages: Project_micropanel.microPages,
		url: '',
		filter: null,
		locale: null,
		groupSize: null,

		top: 0,
		bottom: 9999,

		loaded: false,
	},
	created() {
		window.addEventListener('scroll', this.handleScroll)
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	mounted: function() {
		const microPanelSelected = Object.values(Project_micropanel.panels).filter( panel => {
			panelSlug = slug(panel.title)
			selected = Project_micropanel.selected
			return panelSlug == selected;
		})[0]

		const microPageSelected = Object.values(Project_micropanel.microPages).filter( page => {
			pageSlug = slug(page.content.title)
			selected = Project_micropanel.selected
			return pageSlug == selected;
		})[0]


		const microChildSelected = _.flattenDepth(Project_micropanel.microPages.map( parent => {
					return parent.children;
				}), 1).filter( child => {
			childSlug = slug(child.content.title)
			selected = Project_micropanel.selected
			return childSlug == selected;
		})[0]

		if (microPanelSelected) {
			this.frontpage = false;
			this.selectedPanel = Object.values(this.panels).filter(function(panel) {
				return panel.id == microPanelSelected.id;
			})[0];
			if (this.selectedPanel.type == 'submenu'){
				this.subpage = true;
			}
			if (this.selectedPanel.type == 'ibe'){
				document.getElementById('planner_panel').style.display="block";
			};

		}

		if (microPageSelected) {
			this.frontpage = false;
			this.selectedPage =  parseInt(microPageSelected.id);
		}

		if (microChildSelected) {
			this.frontpage = false;
			this.selectedChild =  parseInt(microChildSelected.id);
		}

		let ibePanel = Object.values(this.panels).filter(panel => panel.type == 'ibe')[0]
		if (ibePanel){
			Event.IBE = true
			Event.$on('loadIBE', (p) => {
				this.selectedPanel = ibePanel
			})
		}
		this.loaded = true;

		setInterval(this.countUp.bind(this) , 5000);
	},
	watch: {
		fullUrl: function() {
			history.pushState({}, null, this.fullUrl)
		},
		selectedPanel: function () {
			if (this.selectedPanel){
				this.url = Project_micropanel.pageSlug+'/'+slug(this.selectedPanel.title);
			} else {
				if (!this.selectedPage && !this.selectedChild) {
					this.url = Project_micropanel.pageSlug;
				}
			}
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

			if ( (this.selectedPanel && this.selectedPanel.type == 'ibe') ){
				this.ibeActive = true;
			}
			if ( (this.selectedPanel && this.selectedPanel.type == 'info') ){
				Event.$emit('microbannerOn');
			} else {
				Event.$emit('microbannerOff');
			}
		},
		ibeActive: function(){
			if ( this.ibeActive ){
				document.getElementById('planner_panel').style.display="block"
			} else {
				document.getElementById('planner_panel').style.display="none"
			}
		},
		selectedPage: function() {
			if (this.selectedPage){
				page = this.microPages.filter( page => {
					return page.id == this.selectedPage;
				})[0]
				this.url = Project_micropanel.pageSlug+'/'+slug(page.content.title);
			} else {
				if (!this.selectedPanel && !this.selectedChild) {
					this.url = Project_micropanel.pageSlug;
				}
			}
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
		},
		selectedChild: function() {
			if (this.selectedChild){
				child = _.flattenDepth(Project_micropanel.microPages.map( parent => {
					return parent.children;
				}), 1).filter( page => {
					return page.id == this.selectedChild;
				})[0]

				this.url = Project_micropanel.pageSlug+'/'+slug(child.content.title);
			} else {
				if (!this.selectedPanel && !this.selectedPage) {
					this.url = Project_micropanel.pageSlug;
				}
			}
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
		},


	},
	methods: {
		handleScroll() {
			this.top = window.scrollY;
			this.bottom = document.body.scrollHeight - window.scrollY;
		},
		activateIBE: function(type){
			if (type == 'page_with_ibe') {this.ibeActive='true'};
		},
		bookOnlineLink() {
			if (Event.IBE == true){
				Event.$emit('loadIBE');
			} else {
				window.location.href = '/bookonline?destination='+this.destination.slug
			}
		},
		countUp: function() {
			if (!this.stopTimer){
				this.currentTimer = parseInt(this.currentTimer) + 1;
			}
		},
		deselectAll: function() {
			this.frontpage = false;
			this.subpage = false;
			this.selectedPanel = null;
			this.selectedPage = null;
			this.selectedChild = null;
			this.ibeActive = false;
		},
		selectChild: function(child_id) {
			this.deselectAll();
			this.selectedChild = child_id;
		},
		selectPage: function(page, type, filter) {
			this.deselectAll();

			if (type == 'url') {
				micropage = _.find(this.microPages, (m_page) => {
					return m_page.id == page;
				});
				window.location.href = micropage.url;
			}

			if (type == 'page_with_ibe') {
				this.ibeActive = true;
			}
			if (type == 'packages'){
				this.selectedPage = page;
				if (filter.length){
					Event.selectedPackage = filter;
				}
			}

			if (type == 'page_with_ibe' || type == 'page') {
				this.selectedPage = page;
			}
		},
		selectPanel: function(panel) {
			this.deselectAll();
			if (panel.type == 'submenu'){
				this.subpage = true;
			}
			if (panel.type == 'ibe'){
				this.ibeActive = true;
			}
			if (panel.filter){
				Event.selectedPackage = panel.filter;
			}
			this.selectedPanel = panel;
		},
		closeThis: function(panel = null) {
			this.deselectAll();
			if (panel && panel.panel_id > 0) {
				this.selectedPanel = Object.values(this.panels).filter(function(panel_a) {
					return panel_a.id == panel.panel_id;
				})[0];
				this.subpage = true;
			} else {
				this.frontpage = true;
			}
		},
		associatedPanel: function(button){
			this.deselectAll()

			let result = Object.values(this.panels).filter(function(panel) {
				return panel.id == button.id
			})
			if (result[0].type == 'submenu'){
				this.subpage = true
			}

			if (result[0].filter){
				Event.selectedPackage = result[0].filter
			}
			this.selectedPanel = result[0]
		},
		updateFilter(){
			this.filter = 'x'
		},
		getBlogPost(id){
			fetch( '/api/microsite/blog/'+id )
				.then(response => response.text())
				.then( (result) => {
					this.selectedPanel.type = 'selectedBlog'
					this.selectedBlog = result
				})
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

		},
		backToBlogList(){
			this.selectedPanel.type = 'bloglist'
			this.selectedBlog = ''
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

		}
	},
	computed: {
		fullUrl(){
			return this.url+this.packageUrl;
		},
		packageUrl(){
			if (this.selectedPanel && this.selectedPanel.type=='packages' || (this.selectedArticle && this.selectedArticle.content.type == 'packages')) {
				if (this.filter || this.locale || this.groupSize){
					return '/'+(this.locale?this.locale:'all')+'/'+(this.filter?this.filter:'all')+'/'+(this.groupSize?this.groupSize:'all')
				}
			}
			this.filter = null
			this.locale = null
			this.groupSize = null
			return ''
		},
		articlePages: function() {
			pages = this.microPages.filter(function(page) {
				return page.content.type == 'page';
			});
			return _.sortBy(pages, 'order');
		},
		selectedArticleList: function() {
			if (this.selectedPanel && this.selectedPanel.type == 'page_list'){
				pages = _.find(this.microPages, page => page.id == this.selectedPanel.type_id );
				return _.sortBy(pages, 'order');
			}
		},
		selectedArticle: function() {

			child_id = this.selectedChildId;
			parent_id = this.selectedParentId;

			if (parent_id == null){
				return null;
			}

			articleParent = _.find(this.microPages, page => page.id == parent_id );

			var articleParent2 = JSON.parse(JSON.stringify(articleParent));

			if (child_id) {
				selectedChildArticle = _.find(articleParent.children,  child => child.id == child_id );
				articleParent2.content.title = selectedChildArticle.content.title;
				articleParent2.content.content = selectedChildArticle.content.content;
				if (selectedChildArticle.content.banner_url){
					articleParent2.content.banner_url = selectedChildArticle.content.banner_url;
				}
			}


			return articleParent2;
		},
		selectedChildId: function() {
			let child_id = null;
			if (this.selectedPanel && this.selectedPanel.type == 'child_page') {
				child_id = this.selectedPanel.type_id;
			}
			if (this.selectedChild) {
				child_id = this.selectedChild;
			}
			return child_id;
		},
		selectedParentId: function() {
			parent_id = null;

			if (this.selectedPanel && this.selectedPanel.type == 'parent_page') {
				parent_id = this.selectedPanel.type_id;
			}
			if (this.selectedPage) {
				parent_id = this.selectedPage;
			}

			if (this.selectedChildId) {

				parentAttached = this.microPages.filter((parent) => {
					childArray = parent.children.map( child => child.id );
					return _.includes(childArray, this.selectedChildId)
				});

				if (parentAttached.length){
					parent_id = parentAttached[0].id
				}
			}
			return parent_id;
		},
		currentBanner: function() {
			filteredPages = Project_micropanel.microPages.filter(function(page) {
				return page.active;
			});
			if (this.currentTimer < 0 ) {
				this.currentTimer = filteredPages.length-1;
			}
			return this.currentTimer % filteredPages.length;
		},
		filteredPanels: function(){
			_this = this;
			panels = Object.values(this.panels).filter(function(panel) {
				return panel.panel_id==(_this.selectedPanel?_this.selectedPanel.id:0);
			});
			panels = panels.sort(function(a, b) {
				return parseInt(a.order) - parseInt(b.order);
			});
			return panels;
		},

	}
});

function isNumber(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

function slug(string) {
	if (string) {
		return string.toLowerCase().replace(/\W/g, '-')
	}
	return ''
}